import { render, staticRenderFns } from "./personalizacao-canvas.vue?vue&type=template&id=0098c403&scoped=true&"
import script from "./personalizacao-canvas.vue?vue&type=script&lang=js&"
export * from "./personalizacao-canvas.vue?vue&type=script&lang=js&"
import style0 from "./personalizacao-canvas.vue?vue&type=style&index=0&id=0098c403&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0098c403",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0098c403')) {
      api.createRecord('0098c403', component.options)
    } else {
      api.reload('0098c403', component.options)
    }
    module.hot.accept("./personalizacao-canvas.vue?vue&type=template&id=0098c403&scoped=true&", function () {
      api.rerender('0098c403', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/personalizacao-painel/personalizacao-canvas.vue"
export default component.exports